import type { GatedFeature } from '../../config/PricingConfig'
import { LockBadge } from './Chip'

export const UpgradeLockBadge = ({ feature, label }: { feature: GatedFeature; label?: string }) => (
  <LockBadge feature={feature} label={label} />
)
